var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82918 2.49805H3.33083C2.8709 2.49805 2.49805 2.8709 2.49805 3.33083V5.82918C2.49805 6.28911 2.8709 6.66196 3.33083 6.66196H5.82918C6.28911 6.66196 6.66196 6.28911 6.66196 5.82918V3.33083C6.66196 2.8709 6.28911 2.49805 5.82918 2.49805Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6554 2.49805H14.157C13.6971 2.49805 13.3242 2.8709 13.3242 3.33083V5.82918C13.3242 6.28911 13.6971 6.66196 14.157 6.66196H16.6554C17.1153 6.66196 17.4881 6.28911 17.4881 5.82918V3.33083C17.4881 2.8709 17.1153 2.49805 16.6554 2.49805Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82918 13.3242H3.33083C2.8709 13.3242 2.49805 13.6971 2.49805 14.157V16.6554C2.49805 17.1153 2.8709 17.4881 3.33083 17.4881H5.82918C6.28911 17.4881 6.66196 17.1153 6.66196 16.6554V14.157C6.66196 13.6971 6.28911 13.3242 5.82918 13.3242Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4881 13.3242H14.9898C14.548 13.3242 14.1244 13.4997 13.8121 13.8121C13.4997 14.1244 13.3242 14.548 13.3242 14.9898V17.4881",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4883 17.4883V17.4966",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99399 5.8291V8.32745C9.99399 8.76919 9.81852 9.19283 9.50616 9.50518C9.19381 9.81754 8.77016 9.99302 8.32843 9.99302H5.83008",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49805 9.99316H2.50637",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99414 2.49805H10.0025",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99414 13.3242V13.3325",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3242 9.99316H14.157",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4883 9.99316V10.0015",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99414 17.4881V16.6553",
    stroke: "#99A1AF",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.353a32d971ec3f425f12e04b11ee5a4c.svg";
export { ForwardRef as ReactComponent };